import type { Span } from '@opentelemetry/api'
import type { SpanProcessor } from '@opentelemetry/sdk-trace-base'
import type { AnyRouter } from '@tanstack/react-router'

import {
  ATTR_GECKO_COMPONENT_ID,
  ATTR_GECKO_ORG_OR_SITE_ID,
  ATTR_GECKO_ORGANIZATION_ID,
  ATTR_GECKO_SITE_ID,
  ATTR_GECKO_UNIT_ID,
} from './spanAttributes'

/**
 * A SpanProcessor that adds route context attributes to spans.
 * Subscribes to TanStack Router state changes and extracts route params
 * (orgID, siteID, orgOrSiteID, unitID, componentID) to add as span attributes.
 */
export class RouteContextSpanProcessor implements SpanProcessor {
  private router: AnyRouter

  constructor(router: AnyRouter) {
    this.router = router
  }

  onStart(span: Span): void {
    const allParams = this.router.state.matches.reduce<
      Record<string, string | undefined>
    >(
      (acc, match) => ({
        ...acc,
        ...match.params,
      }),
      {}
    )

    // Only set specific attributes when we know the type for certain
    if (allParams.orgID) {
      span.setAttribute(ATTR_GECKO_ORGANIZATION_ID, allParams.orgID)
    }
    if (allParams.siteID) {
      span.setAttribute(ATTR_GECKO_SITE_ID, allParams.siteID)
    }
    // Use combined attribute when type is ambiguous
    if (allParams.orgOrSiteID) {
      span.setAttribute(ATTR_GECKO_ORG_OR_SITE_ID, allParams.orgOrSiteID)
    }
    if (allParams.unitID) {
      span.setAttribute(ATTR_GECKO_UNIT_ID, allParams.unitID)
    }
    if (allParams.componentID) {
      span.setAttribute(ATTR_GECKO_COMPONENT_ID, allParams.componentID)
    }
  }

  onEnd(): void {}
  forceFlush(): Promise<void> {
    return Promise.resolve()
  }
  shutdown(): Promise<void> {
    return Promise.resolve()
  }
}
